import { EmptyState } from '@actinc/dls/components/EmptyState';
import Button from '@mui/material/Button';
import React from 'react';
import LinkExternal from '~/components/LinkExternal';
import getIcon from '~/helpers/getIcon';
import { StyledPaper } from './styles';
const NoRegistrationsFound = (): React.ReactElement => <StyledPaper variant="outlined" data-sentry-element="StyledPaper" data-sentry-component="NoRegistrationsFound" data-sentry-source-file="index.tsx">
    <EmptyState description={<span>
          Sign in to&nbsp;
          <LinkExternal href="https://my.act.org/" kioskModeFallback="MyACT (https://my.act.org)">
            MyACT
          </LinkExternal>
          &nbsp;to register for a test.
        </span>} Icon={getIcon('general.registration')} title="No Online Registrations Found" data-sentry-element="EmptyState" data-sentry-source-file="index.tsx" />

    <LinkExternal href="https://my.act.org/" data-sentry-element="LinkExternal" data-sentry-source-file="index.tsx">
      <Button variant="contained" data-sentry-element="Button" data-sentry-source-file="index.tsx">Register Now</Button>
    </LinkExternal>
  </StyledPaper>;
export default NoRegistrationsFound;